
/* eslint-disable */

import * as Forms from '../../forms';

window.Reverb = window.Reverb || {};
Reverb.Shipping = Reverb.Shipping || {};

Reverb.Shipping.Estimator = (function () {
  const countrySelect = ':input[data-shipping-estimate-field=\'from-countrycode\']';
  const locationSelects = `${countrySelect},:input[data-shipping-estimate-field='from-locality'],:input[data-shipping-estimate-field='from-region']`;
  const shippingEstimateData = 'shipping-estimate-field';

  const packagePresetLink = '[data-package-preset-link]';
  const shippingEstimateButton = '[data-shipping-estimate-submit]';
  const estimatorContainer = '[data-shipping-estimator-container]';
  const estimatorRequiredFieldsHint = '[data-shipping-estimator-required-fields-hint]';
  const estimateForm = '[data-shipping-estimate-form]';

  function hasCompletedLocationFields() {
    return Forms.allFieldsValid($(locationSelects));
  }

  function bindDefaultPackageClick() {
    $(document).on('click', packagePresetLink, (e) => {
      e.preventDefault();
      copyDataToForm($(e.target).closest(packagePresetLink));
    });
  }

  function copyDataToForm(linkClicked) {
    $.each(['weight', 'height', 'width', 'length'], (i, name) => {
      const newValue = linkClicked.data(`package-${name}`);
      setFormField(name, newValue);
    });
  }

  function setFormField(attrName, value) {
    const dataAttrName = attrName.replace('_', '-');
    const input = $(estimatorContainer).find(`input[data-${shippingEstimateData}='${dataAttrName}']`);

    input.val(value);
  }

  function bindEstimateButtonClick() {
    $(document).on('click', shippingEstimateButton, handleEstimateButtonClick);
  }

  function handleEstimateButtonClick(event) {
    event.preventDefault();
    const $button = $(event.target);
    const $activeEstimateForm = $button.parents(estimateForm);
    const hasErrors = !validateAndHighlightFields($activeEstimateForm);

    Forms.disableElement($button);

    if (hasErrors) {
      event.stopImmediatePropagation();
      Forms.enableElement($button);
      return;
    }

    loadEstimateInDom($activeEstimateForm);
  }

  function validateAndHighlightFields($activeEstimateForm) {
    return Forms.validateFields($(estimatorContainer), estimateFields($activeEstimateForm));
  }

  function loadEstimateInDom($activeEstimateForm) {
    const $submit = $activeEstimateForm.find(shippingEstimateButton);
    const resultTarget = $($submit.data('estimate-result-target'));
    const url = $submit.data('submit-path');

    showSpinner(resultTarget);

    return $.post(url, toParams($activeEstimateForm)).done((returnData) => {
      resultTarget.html(returnData);
      resultTarget.removeClass('with-spinner');
    }).fail((xhr) => {
      resultTarget.html(xhr.responseText);
    }).always(() => {
      Forms.enableElement($submit);
    });
  }

  function toParams($activeEstimateForm) {
    const $fields = estimateFields($activeEstimateForm);
    const data = {};
    $fields.each((index, element) => {
      const $el = $(element);
      const attributeName = $el.data(shippingEstimateData).replace('-', '_');
      const attributeValue = $el.val();
      data[attributeName] = attributeValue;
    });
    return data;
  }

  function showSpinner(target) {
    target.addClass('with-spinner');
    target.html('');
    target.show();
    target.spin({ overlay: false });
  }

  function bindLocationSelectsChange() {
    $(document).on('change', locationSelects, () => {
      showHideEstimator();
    });
  }

  function nonUSCountrySelected() {
    const $countryInput = $(countrySelect);

    if ($countryInput.length) {
      return $countryInput.val() !== 'US';
    }

    // if we're rendering on a page without a country select, we'll
    // assume we want to show it (that page may still decide to not
    // render it altogether based on the user's known location).
    return false;
  }

  function showHideEstimator() {
    const $estimatorContainer = $(estimatorContainer);
    const $estimatorRequiredFieldsHint = $(estimatorRequiredFieldsHint);

    if (hasCompletedLocationFields() && !nonUSCountrySelected()) {
      $estimatorRequiredFieldsHint.hide();
      $estimatorContainer.slideDown();
    } else {
      $estimatorContainer.slideUp();
    }
  }

  function estimateFields($activeEstimateForm) {
    const $activeEstimateFormFields = $activeEstimateForm.find(`[data-${shippingEstimateData}]`);
    return $(locationSelects).add($activeEstimateFormFields);
  }

  function copyPostCodeAcrossTabs() {
    const domesticPostalCodeInput = $('#domestic_estimation').find('[data-shipping-estimate-field="from-postal"]');
    const internationalPostalCodeInput = $('#international_estimation').find('[data-shipping-estimate-field="from-postal"]');

    domesticPostalCodeInput.blur( function() {
      const postalCode = $(this).val()
      internationalPostalCodeInput.val(postalCode);
    });
  }

  function init() {
    bindDefaultPackageClick();
    bindEstimateButtonClick();
    bindLocationSelectsChange();
    showHideEstimator();
    copyPostCodeAcrossTabs();
  }

  return {
    init,
  };
}());

$(() => { Reverb.Shipping.Estimator.init(); });
